import { loc } from "../../../core/utils"
import React from "react"

const EXPERIAN_BADEXCUG_CODE = "280"
const ASNEF_EQUIFAX_CODE = "200"

const DynamicFinalPageText = ({ statusCode }) => {
  if (statusCode.includes(EXPERIAN_BADEXCUG_CODE) && statusCode.includes(ASNEF_EQUIFAX_CODE)) {
    return (
      <>
        <p>
          No podemos seguir con tu solicitud de crédito ya que figuras incluido en los ficheros de solvencia patrimonial
          Asnef-Equifax y Experian-BADEXCUG.
        </p>
        <p>
          Si crees que puede tratarse de un error y que la información que hemos recibido de Asnef-Equifax y
          Experian-BADEXCUG es incorrecta, no dudes en dirigirte directamente a Asnef-Equifax en el correo electrónico
          sac@equifax.es, en el Apartado de Correos 10546, 28080-Madrid, o en el teléfono 902 126 000 (opción 4), y a
          Experian-BADEXCUG en el teléfono 916258912, en el Apartado de Correos 1188, 28108-Alcobendas - Madrid, o en el
          correo electrónico badexcug@experian.com, ante los que podrás ejercitar los derechos previstos en la normativa
          de protección de datos.
        </p>
        <p>
          <strong>
            Esperamos poder seguir con tu solicitud de crédito muy pronto para que puedas llevar a cabo tu proyecto. Y,
            sobre todo, te damos las gracias por confiar en nosotros.
          </strong>
        </p>
      </>
    )
  }
  if (statusCode.includes(EXPERIAN_BADEXCUG_CODE)) {
    return (
      <>
        <p>
          No podemos seguir con tu solicitud de crédito ya que figuras incluido en el fichero de solvencia patrimonial
          Experian-BADEXCUG
        </p>
        <p>
          Si crees que puede tratarse de un error y que la información que hemos recibido de Experian-BADEXCUG es
          incorrecta, no dudes en dirigirte directamente a Experian-BADEXCUG en el teléfono 916258912, en el Apartado de
          Correos 1188, 28108 Alcobendas-Madrid, o en el correo electrónico badexcug@experian.com, ante el que podrás
          ejercitar los derechos previstos en la normativa de protección de datos.
        </p>
        <p>
          <strong>
            Esperamos poder seguir con tu solicitud de crédito muy pronto para que puedas llevar a cabo tu proyecto. Y,
            sobre todo, te damos las gracias por confiar en nosotros.
          </strong>
        </p>
      </>
    )
  }
  if (statusCode.includes(ASNEF_EQUIFAX_CODE)) {
    return (
      <>
        <p>
          No podemos seguir con tu solicitud de crédito ya que figuras incluido en el fichero de solvencia patrimonial
          Asnef-Equifax.
        </p>
        <p>
          Si crees que puede tratarse de un error y que la información que hemos recibido de Asnef-Equifax es
          incorrecta, no dudes en dirigirte directamente a Asnef-Equifax en el correo electrónico sac@equifax.es, en el
          Apdo. Correos 10546, 28080 Madrid, o en el teléfono 902 126 000 (opción 4), ante el que podrás ejercitar los
          derechos previstos en la normativa de protección de datos.
        </p>
        <p>
          <strong>
            Esperamos poder seguir con tu solicitud de crédito muy pronto para que puedas llevar a cabo tu proyecto. Y,
            sobre todo, te damos las gracias por confiar en nosotros.
          </strong>
        </p>
      </>
    )
  }
  return (
    <>
      <p>{loc`We regret to inform you that we cannot give a favorable response to your request.`}</p>
      <p>
        <strong>{loc`Your order is canceled. The amount of the upfront will not be deducted from you.`}</strong>
      </p>
    </>
  )
}

export default DynamicFinalPageText
